import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export default function ICTele({}: ISvgIcon): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_19499)">
        <path
          d="M11.9998 23.5551C18.3838 23.5551 23.5558 18.3831 23.5558 12.0001C23.5558 5.61609 18.3838 0.444092 11.9998 0.444092C5.61685 0.444092 0.443848 5.61609 0.443848 12.0001C0.443848 18.3831 5.61685 23.5551 11.9998 23.5551ZM6.30285 11.0821L17.4448 6.78609C17.9618 6.59909 18.4138 6.91209 18.2458 7.69409L16.3498 16.6301C16.2098 17.2641 15.8328 17.4181 15.3058 17.1201L12.4168 14.9901L11.0238 16.3331C10.8698 16.4871 10.7398 16.6171 10.4408 16.6171L10.6458 13.6771L15.9998 8.84009C16.2328 8.63509 15.9478 8.52009 15.6408 8.72309L9.02485 12.8901L6.17185 12.0001C5.55285 11.8041 5.53985 11.3811 6.30285 11.0831V11.0821Z"
          fill="#8E8E92"
        />
      </g>
      <defs>
        <clipPath id="clip0_336_19499">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
